import { NATERA_TAGS } from '../config'

export function getNateraTagLabelByCode(code: string) {
  const codeObj = NATERA_TAGS.find((c) => c.code === code)
  return codeObj?.label ?? null
}
